
const TransportSection = () => {
  const transportMethods = [
    {
      icon: 'ri-subway-line',
      title: '捷運',
      description: '前金捷運站3號出口步行約 3 分鐘',
      highlight: true,
    },
    {
      icon: 'ri-car-line',
      title: '自行開車',
      description: '鄰近有收費停車場，交通便利',
      highlight: false,
    },
  ];

  return (
    <section id="transport" className="py-20 bg-white" aria-labelledby="transport-title">
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-12">
          <span className="inline-block px-4 py-1 bg-baby-blue-100 text-baby-blue-600 rounded-full text-sm font-medium mb-4">
            交通資訊
          </span>
          <h2 id="transport-title" className="text-3xl font-bold text-gray-800 mb-4">
            <a href="#transport" className="hover:text-baby-blue-600 transition-colors">高雄市前金區日照中心交通指南</a>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            <strong>前金日間照顧中心</strong>位於<strong>高雄市前金區</strong>，鄰近前金捷運站，交通四通八達，方便家屬接送。<strong>高雄市前金日照推薦</strong>交通便利首選。
          </p>
        </header>

        <div className="grid lg:grid-cols-2 gap-10 items-start">
          <figure className="rounded-2xl overflow-hidden shadow-lg h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.0!2d120.29!3d22.62!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e04f0a0a0a0a1%3A0x1234567890abcdef!2z5YmN6YeR5o2356uL56uZ!5e0!3m2!1szh-TW!2stw!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="高雄市前金區日照中心位置地圖"
              aria-label="前金日間照顧中心交通地圖"
            ></iframe>
          </figure>

          <article className="space-y-4">
            <div className="bg-gradient-to-r from-baby-blue-50 to-cream-50 rounded-2xl p-6 border border-baby-blue-100">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-baby-blue-300 rounded-xl flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-2xl" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 mb-1">中心地址</h3>
                  <address className="not-italic text-gray-600">高雄市前金區文武二街163號5樓</address>
                  <a 
                    href="https://maps.google.com/?q=高雄市前金區文武二街163號5樓" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-baby-blue-500 text-sm mt-2 hover:text-baby-blue-600 transition-colors cursor-pointer"
                    title="導航至高雄市前金區日照中心"
                  >
                    <i className="ri-navigation-line" aria-hidden="true"></i>
                    開啟 Google 地圖導航
                  </a>
                </div>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {transportMethods.map((method, index) => (
                <div
                  key={index}
                  className={`rounded-xl p-5 transition-all hover:shadow-md cursor-default ${
                    method.highlight
                      ? 'bg-baby-blue-50 border-2 border-baby-blue-200'
                      : 'bg-cream-50 border border-cream-200'
                  }`}
                >
                  <div className="flex items-start gap-3">
                    <div
                      className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${
                        method.highlight
                          ? 'bg-baby-blue-300 text-white'
                          : 'bg-cream-200 text-cream-600'
                      }`}
                    >
                      <i className={`${method.icon} text-xl`} aria-hidden="true"></i>
                    </div>
                    <div>
                      <h4 className={`font-bold mb-1 ${
                        method.highlight ? 'text-baby-blue-600' : 'text-gray-700'
                      }`}>
                        {method.title}
                        {method.highlight && (
                          <span className="ml-2 text-xs bg-baby-blue-200 text-baby-blue-600 px-2 py-0.5 rounded-full">
                            推薦
                          </span>
                        )}
                      </h4>
                      <p className="text-sm text-gray-500">{method.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-cream-100 rounded-xl p-4 flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-cream-300 rounded-lg flex-shrink-0">
                <i className="ri-information-line text-cream-700" aria-hidden="true"></i>
              </div>
              <div>
                <h4 className="font-medium text-gray-700 text-sm mb-1">溫馨提醒</h4>
                <p className="text-xs text-gray-500">
                  首次參訪<strong>高雄市前金區日照中心</strong>建議先來電預約，我們將安排專人為您導覽介紹中心環境與服務內容。
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default TransportSection;
